export default "__VITE_ASSET__D5OYjMZ6__"